export enum EDatePickerFormat {
	day = 'dd/MM/yyyy',
	week = 'I/R',
	month = 'MM/yyyy',
	quarter = 'yyyy, QQQ',
	year = 'yyyy'
}